module.exports = "https://w.yxzs.360.cn/singleapp/simulator-site-old/img/p4.bbc8c5f4.png";